import { render, staticRenderFns } from "./Apprentices.vue?vue&type=template&id=9ed018d8&scoped=true&"
import script from "./Apprentices.vue?vue&type=script&lang=js&"
export * from "./Apprentices.vue?vue&type=script&lang=js&"
import style0 from "./Apprentices.vue?vue&type=style&index=0&id=9ed018d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed018d8",
  null
  
)

export default component.exports